// import React, { useState, useEffect, useCallback } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   FiRefreshCw, FiCheckCircle, FiXCircle,
//   FiDatabase, FiAlertCircle,
// } from 'react-icons/fi';
// import { testSapConnection, sapSync } from '../../utils/grirApi';

// const API_LABELS = {
//   API_MATERIAL_DOCUMENT_SRV:       'Material Document SRV',
//   API_SUPPLIERINVOICE_PROCESS_SRV: 'Supplier Invoice SRV',
//   API_PURCHASEORDER_PROCESS_SRV:   'Purchase Order SRV',
//   API_BUSINESS_PARTNER:            'Business Partner',
// };

// const apiRowVariants = {
//   hidden:  { opacity: 0, x: -16 },
//   visible: { opacity: 1, x: 0, transition: { type: 'spring', stiffness: 200, damping: 22 } },
// };
// const apiContainerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.07 } } };

// const GRIRSapSync = () => {
//   const [connData, setConnData]         = useState(null);
//   const [connLoading, setConnLoading]   = useState(true);
//   const [connError, setConnError]       = useState('');

//   const today = new Date().toISOString().split('T')[0];
//   const [syncForm, setSyncForm] = useState({ start_date: '2026-01-01', end_date: today, sync_gr: true, sync_ir: true });
//   const [syncing, setSyncing]       = useState(false);
//   const [syncResult, setSyncResult] = useState(null);
//   const [syncError, setSyncError]   = useState('');

//   const testConnection = useCallback(() => {
//     setConnLoading(true); setConnError('');
//     testSapConnection()
//       .then(setConnData)
//       .catch((err) => setConnError(err.message))
//       .finally(() => setConnLoading(false));
//   }, []);

//   useEffect(() => { testConnection(); }, [testConnection]);

//   const handleSync = async () => {
//     if (!syncForm.sync_gr && !syncForm.sync_ir) { setSyncError('Select at least one — GR or IR.'); return; }
//     setSyncing(true); setSyncResult(null); setSyncError('');
//     try {
//       const data = await sapSync(syncForm);
//       setSyncResult(data);
//     } catch (err) {
//       setSyncError(err.message);
//     } finally {
//       setSyncing(false);
//     }
//   };

//   return (
//     <div className="grir-sap-page">
//       {/* ── Connection status ── */}
//       <motion.div
//         className="grir-card"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
//       >
//         <div className="grir-card-header">
//           <div className="grir-card-title"><FiDatabase size={16} /><span>SAP Connection Status</span></div>
//           <motion.button
//             className="grir-icon-btn"
//             onClick={testConnection}
//             title="Refresh"
//             disabled={connLoading}
//             animate={{ rotate: connLoading ? 360 : 0 }}
//             transition={{ repeat: connLoading ? Infinity : 0, duration: 0.7, ease: 'linear' }}
//             whileTap={{ scale: 0.88 }}
//           >
//             <FiRefreshCw size={14} />
//           </motion.button>
//         </div>

//         {connLoading && (
//           <div className="grir-loading-inline"><div className="grir-spinner-sm" /><span>Testing connection…</span></div>
//         )}
//         {connError && (
//           <div className="grir-feedback error" style={{ margin: '16px 20px' }}><FiAlertCircle size={14} /> {connError}</div>
//         )}
//         <AnimatePresence>
//           {connData && !connLoading && (
//             <motion.div key="conn" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
//               <div className="grir-sap-url-info">
//                 <span className="grir-sap-url-label">SAP URL</span>
//                 <span className="grir-sap-url-value">{connData.sap_base_url}</span>
//                 <span className="grir-sap-url-label" style={{ marginLeft: 20 }}>Client</span>
//                 <span className="grir-sap-url-value">{connData.sap_client}</span>
//               </div>

//               <motion.div
//                 className="grir-api-list"
//                 variants={apiContainerVariants}
//                 initial="hidden"
//                 animate="visible"
//               >
//                 {Object.entries(connData.api_status || {}).map(([key, ok]) => (
//                   <motion.div key={key} className={`grir-api-item ${ok ? 'ok' : 'fail'}`} variants={apiRowVariants}>
//                     {ok
//                       ? <FiCheckCircle size={17} style={{ color: '#22c55e', flexShrink: 0 }} />
//                       : <FiXCircle     size={17} style={{ color: '#ef4444', flexShrink: 0 }} />
//                     }
//                     <div className="grir-api-info">
//                       <span className="grir-api-name">{API_LABELS[key] || key}</span>
//                       <span className="grir-api-key">{key}</span>
//                     </div>
//                     <span className={`grir-sap-status-pill ${ok ? 'ok' : 'fail'}`}>
//                       {ok ? 'Connected' : 'Unreachable'}
//                     </span>
//                   </motion.div>
//                 ))}
//               </motion.div>

//               <div className="grir-card-footer">
//                 <div className={`grir-overall-status ${connData.all_connected ? 'ok' : 'fail'}`}>
//                   {connData.all_connected
//                     ? <><FiCheckCircle size={15} /> All APIs connected</>
//                     : <><FiXCircle size={15} /> Some APIs unreachable</>
//                   }
//                 </div>
//                 <motion.button className="grir-btn secondary" onClick={testConnection} whileTap={{ scale: 0.96 }}>
//                   <FiRefreshCw size={13} /> Test Again
//                 </motion.button>
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </motion.div>

//       {/* ── Sync form ── */}
//       <motion.div
//         className="grir-card"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.14, duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
//       >
//         <div className="grir-card-header">
//           <div className="grir-card-title"><FiRefreshCw size={16} /><span>Sync Data from SAP</span></div>
//         </div>

//         <div className="grir-form-grid">
//           <div className="grir-form-group">
//             <label>Start Date</label>
//             <input className="grir-input" type="date" value={syncForm.start_date} onChange={(e) => setSyncForm({ ...syncForm, start_date: e.target.value })} />
//           </div>
//           <div className="grir-form-group">
//             <label>End Date</label>
//             <input className="grir-input" type="date" value={syncForm.end_date} onChange={(e) => setSyncForm({ ...syncForm, end_date: e.target.value })} />
//           </div>
//         </div>

//         <div className="grir-checkbox-row">
//           <label className="grir-checkbox-label">
//             <input type="checkbox" checked={syncForm.sync_gr} onChange={(e) => setSyncForm({ ...syncForm, sync_gr: e.target.checked })} />
//             <span>Sync GR Records</span>
//           </label>
//           <label className="grir-checkbox-label">
//             <input type="checkbox" checked={syncForm.sync_ir} onChange={(e) => setSyncForm({ ...syncForm, sync_ir: e.target.checked })} />
//             <span>Sync IR Records</span>
//           </label>
//         </div>

//         <AnimatePresence>
//           {syncError && (
//             <motion.div key="se" className="grir-feedback error" style={{ margin: '12px 20px 0' }}
//               initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
//               <FiAlertCircle size={14} /> {syncError}
//             </motion.div>
//           )}
//           {syncResult && (
//             <motion.div key="sr" className="grir-feedback success" style={{ margin: '12px 20px 0' }}
//               initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
//               <FiCheckCircle size={14} />
//               <span>Sync complete — <strong>{syncResult.gr_records} GR</strong> and <strong>{syncResult.ir_records} IR</strong> records synced. Batch: <code>{syncResult.batch_id}</code></span>
//             </motion.div>
//           )}
//         </AnimatePresence>

//         <div className="grir-card-footer">
//           <motion.button className="grir-btn primary" onClick={handleSync} disabled={syncing} whileTap={{ scale: 0.96 }}>
//             {syncing ? (<><div className="grir-btn-spinner" /> Syncing…</>) : (<><FiRefreshCw size={14} /> Sync Now</>)}
//           </motion.button>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default GRIRSapSync;



import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FiRefreshCw, FiCheckCircle, FiXCircle,
  FiDatabase, FiAlertCircle,
} from 'react-icons/fi';
import { useGrirApi } from './GrirApiContext';

const API_LABELS = {
  API_MATERIAL_DOCUMENT_SRV: 'Material Document SRV',
  API_SUPPLIERINVOICE_PROCESS_SRV: 'Supplier Invoice SRV',
  API_PURCHASEORDER_PROCESS_SRV: 'Purchase Order SRV',
  API_BUSINESS_PARTNER: 'Business Partner',
};

const apiRowVariants = {
  hidden: { opacity: 0, x: -16 },
  visible: { opacity: 1, x: 0, transition: { type: 'spring', stiffness: 200, damping: 22 } },
};
const apiContainerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.07 } } };

const GRIRSapSync = () => {
  const { testSapConnection, sapSync } = useGrirApi();
  const [connData, setConnData] = useState(null);
  const [connLoading, setConnLoading] = useState(true);
  const [connError, setConnError] = useState('');

  const [syncForm, setSyncForm] = useState({ start_date: '', end_date: '', sync_gr: true, sync_ir: true });
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);
  const [syncError, setSyncError] = useState('');

  const testConnection = useCallback(() => {
    setConnLoading(true); setConnError('');
    testSapConnection()
      .then(setConnData)
      .catch((err) => setConnError(err.message))
      .finally(() => setConnLoading(false));
  }, [testSapConnection]);

  useEffect(() => { testConnection(); }, [testConnection]);

  const handleSync = async () => {
    if (!syncForm.sync_gr && !syncForm.sync_ir) { setSyncError('Select at least one — GR or IR.'); return; }
    setSyncing(true); setSyncResult(null); setSyncError('');
    try {
      const data = await sapSync(syncForm);
      setSyncResult(data);
    } catch (err) {
      setSyncError(err.message);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="grir-sap-page">
      {/* ── Connection status ── */}
      <motion.div
        className="grir-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="grir-card-header">
          <div className="grir-card-title"><FiDatabase size={16} /><span>SAP Connection Status</span></div>
          <motion.button
            className="grir-icon-btn"
            onClick={testConnection}
            title="Refresh"
            disabled={connLoading}
            animate={{ rotate: connLoading ? 360 : 0 }}
            transition={{ repeat: connLoading ? Infinity : 0, duration: 0.7, ease: 'linear' }}
            whileTap={{ scale: 0.88 }}
          >
            <FiRefreshCw size={14} />
          </motion.button>
        </div>

        {connLoading && (
          <div className="grir-loading-inline"><div className="grir-spinner-sm" /><span>Testing connection…</span></div>
        )}
        {connError && (
          <div className="grir-feedback error" style={{ margin: '16px 20px' }}><FiAlertCircle size={14} /> {connError}</div>
        )}
        <AnimatePresence>
          {connData && !connLoading && (
            <motion.div key="conn" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
              <div className="grir-sap-url-info">
                <span className="grir-sap-url-label">SAP URL</span>
                <span className="grir-sap-url-value">{connData.sap_base_url}</span>
                <span className="grir-sap-url-label" style={{ marginLeft: 20 }}>Client</span>
                <span className="grir-sap-url-value">{connData.sap_client}</span>
              </div>

              <motion.div
                className="grir-api-list"
                variants={apiContainerVariants}
                initial="hidden"
                animate="visible"
              >
                {Object.entries(connData.api_status || {}).map(([key, ok]) => (
                  <motion.div key={key} className={`grir-api-item ${ok ? 'ok' : 'fail'}`} variants={apiRowVariants}>
                    {ok
                      ? <FiCheckCircle size={17} style={{ color: '#22c55e', flexShrink: 0 }} />
                      : <FiXCircle size={17} style={{ color: '#ef4444', flexShrink: 0 }} />
                    }
                    <div className="grir-api-info">
                      <span className="grir-api-name">{API_LABELS[key] || key}</span>
                      <span className="grir-api-key">{key}</span>
                    </div>
                    <span className={`grir-sap-status-pill ${ok ? 'ok' : 'fail'}`}>
                      {ok ? 'Connected' : 'Unreachable'}
                    </span>
                  </motion.div>
                ))}
              </motion.div>

              <div className="grir-card-footer">
                <div className={`grir-overall-status ${connData.all_connected ? 'ok' : 'fail'}`}>
                  {connData.all_connected
                    ? <><FiCheckCircle size={15} /> All APIs connected</>
                    : <><FiXCircle size={15} /> Some APIs unreachable</>
                  }
                </div>
                <motion.button className="grir-btn secondary" onClick={testConnection} whileTap={{ scale: 0.96 }}>
                  <FiRefreshCw size={13} /> Test Again
                </motion.button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      {/* ── Sync form ── */}
      <motion.div
        className="grir-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.14, duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="grir-card-header">
          <div className="grir-card-title"><FiRefreshCw size={16} /><span>Sync Data from SAP</span></div>
        </div>

        <div className="grir-form-grid">
          <div className="grir-form-group">
            <label>Start Date</label>
            <input className="grir-input" type="date" value={syncForm.start_date} onChange={(e) => setSyncForm({ ...syncForm, start_date: e.target.value })} />
          </div>
          <div className="grir-form-group">
            <label>End Date</label>
            <input className="grir-input" type="date" value={syncForm.end_date} onChange={(e) => setSyncForm({ ...syncForm, end_date: e.target.value })} />
          </div>
        </div>

        <div className="grir-checkbox-row">
          <label className="grir-checkbox-label">
            <input type="checkbox" checked={syncForm.sync_gr} onChange={(e) => setSyncForm({ ...syncForm, sync_gr: e.target.checked })} />
            <span>Sync GR Records</span>
          </label>
          <label className="grir-checkbox-label">
            <input type="checkbox" checked={syncForm.sync_ir} onChange={(e) => setSyncForm({ ...syncForm, sync_ir: e.target.checked })} />
            <span>Sync IR Records</span>
          </label>
        </div>

        <AnimatePresence>
          {syncError && (
            <motion.div key="se" className="grir-feedback error" style={{ margin: '12px 20px 0' }}
              initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
              <FiAlertCircle size={14} /> {syncError}
            </motion.div>
          )}
          {syncResult && (
            <motion.div key="sr" className="grir-feedback success" style={{ margin: '12px 20px 0' }}
              initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
              <FiCheckCircle size={14} />
              <span>Sync complete — <strong>{syncResult.gr_records} GR</strong> and <strong>{syncResult.ir_records} IR</strong> records synced. Batch: <code>{syncResult.batch_id}</code></span>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="grir-card-footer">
          <motion.button className="grir-btn primary" onClick={handleSync} disabled={syncing} whileTap={{ scale: 0.96 }}>
            {syncing ? (<><div className="grir-btn-spinner" /> Syncing…</>) : (<><FiRefreshCw size={14} /> Sync Now</>)}
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default GRIRSapSync;
